export default {
  methods: {
    getEstablecimiento() {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var identity = JSON.parse(localStorage.getItem("usuario"));
      var idEstablecimiento = app.view.main.router.currentRoute.params.idEstablecimiento;
      var url = window.global.url + "establecimientos/" + idEstablecimiento;
      app.preloader.show();
      app.request.json(url, function (response) {
        // console.log(response)
        if (response.code == 200) {
          var establecimiento = response.establecimiento;
          $('.page[data-name="establecimiento-mod"] input[name="nombre"]').val(establecimiento.nombre);
          $('.page[data-name="establecimiento-mod"] input[name="direccion"]').val(establecimiento.direccion);
          $('.page[data-name="establecimiento-mod"] input[name="whatsapp"]').val(establecimiento.whatsapp);
          $('.page[data-name="establecimiento-mod"] input[name="telefono"]').val(establecimiento.telefono);
          $('.page[data-name="establecimiento-mod"] input[name="email"]').val(establecimiento.email);
          app.preloader.hide();
        } else {
          app.preloader.hide();
          app.dialog.alert("Error");
        }
      }, function (xhr, status) {
        app.preloader.hide();
        console.log(xhr);
        console.log(status);
        app.dialog.alert("Error general");
      });
    },

    modificarEstablecimiento() {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var identity = JSON.parse(localStorage.getItem("usuario"));
      var idEstablecimiento = app.view.main.router.currentRoute.params.idEstablecimiento;
      var url = window.global.url + "establecimientos/datos/" + idEstablecimiento;
      var nombre = $('.page[data-name="establecimiento-mod"] input[name="nombre"]').val().trim();
      var direccion = $('.page[data-name="establecimiento-mod"] input[name="direccion"]').val().trim();
      var whatsapp = $('.page[data-name="establecimiento-mod"] input[name="whatsapp"]').val().trim();
      var telefono = $('.page[data-name="establecimiento-mod"] input[name="telefono"]').val().trim();
      var email = $('.page[data-name="establecimiento-mod"] input[name="email"]').val().trim();
      var establecimiento = {
        id_establecimiento: idEstablecimiento,
        nombre: nombre,
        direccion: direccion,
        whatsapp: whatsapp,
        telefono: telefono,
        email: email
      };
      app.preloader.show();
      app.request({
        headers: {
          'Authorization': localStorage.getItem('token')
        },
        url: url,
        dataType: 'json',
        contentType: "application/json",
        method: 'PUT',
        data: establecimiento,
        statusCode: {
          404: function (xhr) {
            console.log("URL not found");
          },
          400: function (xhr) {
            console.log("Bad request. Some of the inputs provided to the request aren't valid.");
          },
          401: function (xhr) {
            console.log("Not authenticated. The user session isn't valid.");
          },
          403: function (xhr) {
            // console.log("The user isn't authorized to perform the specified request.");
            app.views.main.router.navigate({
              path: '/'
            });
          },
          500: function (xhr) {
            console.log("Internal server error. Additional details will be contained on the server logs.");
          },
          201: function (xhr) {
            console.log("The requested resource has been created.");
          }
        },
        success: function (data, status, xhr) {
          // console.log(data);
          if (data.status == 'success') {
            app.preloader.hide();
            app.dialog.alert("Datos modificados con éxito.");
          } else {
            app.preloader.hide();
            app.dialog.alert("Error al modificar el establecimiento.");
          }
        },
        error: function (xhr, status) {
          app.preloader.hide();
          console.log(xhr);
          console.log(JSON.stringify(xhr));
          console.log(status);
          app.dialog.alert("Error al modificar la establecimiento");
        }
      });
    }

  },
  on: {
    pageInit() {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      self.getEstablecimiento();
      $('.page[data-name="establecimiento-mod"] .button-guardar-cambios').on('click', function () {
        self.modificarEstablecimiento();
      });
    }

  },
  id: '0380a25bed',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=establecimiento-mod><!-- Top Navbar --><div class=navbar><div class=navbar-bg></div><div class=navbar-inner><div class=left><a href=# class="link back"><i class="icon icon-back"></i> <span class=if-not-md>Atrás</span></a></div><div class="title sliding">Editar establecimiento</div><div class=right></div></div></div><!-- Scrollable page content--><div class=page-content><div class=block><p>Editar datos del establecimiento.</p></div><div class="list no-hairlines-md"><ul><li class="item-content item-input"><div class=item-media><i class="icon fas fa-store-alt"></i></div><div class=item-inner><div class="item-title item-label">Nombre</div><div class=item-input-wrap><input type=text name=nombre placeholder="Nombre del establecimiento" maxlength=45 required validate> <span class=input-clear-button></span></div></div></li><li class="item-content item-input"><div class=item-media><i class="icon fas fa-map-marker-alt"></i></div><div class=item-inner><div class="item-title item-label">Dirección</div><div class=item-input-wrap><input type=text name=direccion placeholder=Dirección maxlength=45 required validate> <span class=input-clear-button></span></div></div></li><li class="item-content item-input item-input-with-info"><div class=item-media><i class="icon fab fa-whatsapp"></i></div><div class=item-inner><div class="item-title item-label">Whatsapp</div><div class=item-input-wrap><input type=number name=whatsapp placeholder="Ej: 5492254123456" required validate pattern=[0-9]* data-error-message="Sólo números"> <span class=input-clear-button></span><div class=item-input-info>Debe incluir 549 y el número de celular sin 0 y sin 15</div></div></div></li><li class="item-content item-input item-input-with-info"><div class=item-media><i class="icon fas fa-phone"></i></div><div class=item-inner><div class="item-title item-label">Teléfono</div><div class=item-input-wrap><input type=number name=telefono placeholder=Teléfono required validate pattern=[0-9]* data-error-message="Sólo números"> <span class=input-clear-button></span></div></div></li><li class="item-content item-input item-input-with-info"><div class=item-media><i class="icon fas fa-envelope"></i></div><div class=item-inner><div class="item-title item-label">E-mail</div><div class=item-input-wrap><input type=email name=email placeholder=E-mail maxlength=45 required validate> <span class=input-clear-button></span></div></div></li></ul><div class=block><button class="col button button-guardar-cambios button-fill button-round">Guardar cambios</button></div></div></div></div>';
      return r;
    }(this);
  },

  styleScoped: false
};